import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-basket-dialog',
  templateUrl: './basket-dialog.component.html',
  styleUrls: ['./basket-dialog.component.scss'],
})
export class BasketDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<BasketDialogComponent>) {}

  ngOnInit() {}

  stay() {
    this.dialogRef.close(true);
  }
}
